import { validatorTypes } from '@data-driven-forms/react-form-renderer';

const delhivery3plFieldMap = {
  fields: [
    {
      component: 'radio',
      label: 'Gender',
      name: 'gender',
      options: [
        {
          label: 'Male',
          value: 'male',
        },
        {
          label: 'Female',
          value: 'female',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
    },
    {
      component: 'date-picker',
      label: 'Date Of Birth',
      name: 'dateOfBirth',
      isRequired: true,
      inputReadOnly: true,
      validate: [
        {
          type: 'required',
        },
      ],
    },
    {
      component: 'text-field',
      name: 'fathersName',
      label: 'Father Name',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
      placeholder: 'Enter your father name',
    },
    {
      component: 'textarea',
      name: 'presentAddress',
      label: 'Current Address',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
        {
          type: validatorTypes.MIN_LENGTH,
          threshold: 15,
          message: 'Address must be minimum 15 characters',
        },
      ],
      placeholder: 'Enter your current address',
    },
    {
      component: 'text-field',
      name: 'presentAddressCity',
      label: 'City',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
      placeholder: 'Enter your current city',
    },
    {
      component: 'text-field',
      name: 'presentAddressPincode',
      label: 'Pincode',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
        {
          type: validatorTypes.PATTERN,
          pattern: /^(?=[0-9]*$)(?:.{4}|.{6})$/,
          message: 'PIN Code is incorrect',
        },
      ],
      placeholder: 'Enter you current address pincode',
    },
    {
      component: 'checkbox',
      name: 'addressTypeCheckbox',
      label: 'Is premanent Address same as current address',
      isRequired: false,
      condition: {
        when: 'addressTypeCheckbox',
        is: true,
        then: {
          visible: true,
          disable: true,
          set: formState => {
            return {
              permanentAddress: formState.values.presentAddress,
              permanentAddressPincode: formState.values.presentAddressPincode,
              permanentAddressCity: formState.values.presentAddressCity,
            };
          },
        },
        else: {
          visible: true,
          disable: false,
          set: formState => {
            return { permanentAddress: '', permanentAddressPincode: '', permanentAddressCity: '' };
          },
        },
      },
    },
    {
      component: 'textarea',
      name: 'permanentAddress',
      label: 'Permanent Address',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
        {
          type: validatorTypes.MIN_LENGTH,
          threshold: 15,
          message: 'Address must be minimum 15 characters',
        },
      ],
      placeholder: 'Enter your permanent address',
      // resolveProps: (_props, _field, formOptions) =>
      //   formOptions.getState().values.addressTypeCheckbox
      //     ? { isDisabled: true }
      //     : { isDisabled: false },
    },
    {
      component: 'text-field',
      name: 'permanentAddressCity',
      label: 'City',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
      placeholder: 'Enter your permanent city',
      // resolveProps: (_props, _field, formOptions) =>
      //   formOptions.getState().values.addressTypeCheckbox
      //     ? { isDisabled: true }
      //     : { isDisabled: false },
    },
    {
      component: 'text-field',
      name: 'permanentAddressPincode',
      label: 'Pincode',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
        {
          type: validatorTypes.PATTERN,
          pattern: /^(?=[0-9]*$)(?:.{4}|.{6})$/,
          message: 'PIN Code is incorrect',
        },
      ],
      placeholder: 'Enter you permanent address pincode',
      // resolveProps: (_props, _field, formOptions) =>
      //   formOptions.getState().values.addressTypeCheckbox
      //     ? { isDisabled: true }
      //     : { isDisabled: false },
    },
    {
      "component": "select",
      "label": "Locality Preference",
      "placeholder": 'Please choose a locality',
      "name": "delhivery3plCompanyHubPreference",
      "simpleValue": true,
      "isRequired": true,
      "validate": [
        {
          type: 'required',
        }
      ],
      "options": []
    }
  ],
};

export default delhivery3plFieldMap;
